/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShadowSubsystemActionOneOf
 */
export interface ShadowSubsystemActionOneOf {
    /**
     * 
     */
    tool: ShadowSubsystemActionOneOfToolEnum;
    /**
     * 
     */
    instructions: string;
}


/**
 * @export
 */
export const ShadowSubsystemActionOneOfToolEnum = {
    HumanReview: 'human_review',
} as const;
export type ShadowSubsystemActionOneOfToolEnum = typeof ShadowSubsystemActionOneOfToolEnum[keyof typeof ShadowSubsystemActionOneOfToolEnum];


/**
 * Check if a given object implements the ShadowSubsystemActionOneOf interface.
 */
export function instanceOfShadowSubsystemActionOneOf(value: object): value is ShadowSubsystemActionOneOf {
    if (!('tool' in value) || value['tool'] === undefined) return false;
    if (value['tool'] !== 'human_review') return false;
    
    if (!('instructions' in value) || value['instructions'] === undefined) return false;
    return true;
}

export function ShadowSubsystemActionOneOfFromJSON(json: any): ShadowSubsystemActionOneOf {
    return ShadowSubsystemActionOneOfFromJSONTyped(json, false);
}

export function ShadowSubsystemActionOneOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemActionOneOf {
    if (json == null) {
        return json;
    }
    return {
        
        'tool': json['tool'],
        'instructions': json['instructions'],
    };
}

export function ShadowSubsystemActionOneOfToJSON(json: any): ShadowSubsystemActionOneOf {
    return ShadowSubsystemActionOneOfToJSONTyped(json, false);
}

export function ShadowSubsystemActionOneOfToJSONTyped(value?: ShadowSubsystemActionOneOf | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tool': value['tool'],
        'instructions': value['instructions'],
    };
}

